// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47ef7d66","453":"14a46a46","455":"758e3fd2","644":"236dd8b9"}[chunkId] + ".chunk.js";
};